<template>
    <transition name="slide-up">
        <div v-if="showBanner" class="cookie-banner-wrapper fixed-bottom mb-4 px-3">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-xl-11">
                        <div
                            class="bg-white rounded-4 shadow-lg p-4 d-flex flex-column flex-md-row align-items-center gap-3 gap-md-4 border-start border-4 cookie-border">
                            <div class="cookie-text-container text-center text-md-start">
                                <h6 class="fw-bold text-dark mb-2">
                                    <i class="bi bi-cookie text-warning me-2 fs-5"></i>
                                    Sua privacidade é importante para nós
                                </h6>
                                <p class="small text-secondary mb-0" style="line-height: 1.5;">
                                    Nós utilizamos cookies e tecnologias para melhorar a sua experiência, analisar o
                                    tráfego e personalizar conteúdos. Ao continuar navegando, você concorda com a nossa
                                    <a href="#" data-bs-toggle="modal" data-bs-target="#termsOfUseModal"
                                        class="fw-bold text-decoration-underline" style="color: #561569;">
                                        Política de Privacidade e Termos
                                    </a>.
                                </p>
                            </div>
                            <div
                                class="cookie-buttons-container d-flex flex-column flex-sm-row gap-2 justify-content-center mt-3 mt-md-0">
                                <button class="btn btn-light border fw-medium rounded-pill px-4 py-2"
                                    @click="acceptEssential">
                                    Apenas Essenciais
                                </button>
                                <button class="btn btn-pmg-primary fw-bold rounded-pill px-4 py-2 shadow-sm"
                                    @click="acceptAll">
                                    Aceitar Tudo
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'CookieConsent',
    data() {
        return {
            showBanner: false
        }
    },
    mounted() {
        const cookieStatus = localStorage.getItem('dailypag_cookie_consent');
        if (!cookieStatus) {
            setTimeout(() => {
                this.showBanner = true;
            }, 800);
        }
    },
    methods: {
        acceptAll() {
            localStorage.setItem('dailypag_cookie_consent', 'all');
            this.showBanner = false;
        },
        acceptEssential() {
            localStorage.setItem('dailypag_cookie_consent', 'essential');
            this.showBanner = false;
        }
    }
}
</script>

<style scoped>
.cookie-banner-wrapper {
    z-index: 1050;
}

.cookie-border {
    border-color: #561569 !important;
}

.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-up-enter-from,
.slide-up-leave-to {
    opacity: 0;
    transform: translateY(100px);
}
.cookie-text-container {
    flex: 1 1 auto;
    min-width: 0; 
}

.cookie-buttons-container {
    flex: 0 0 auto;
    white-space: nowrap;
}

@media (max-width: 767px) {
    .cookie-buttons-container {
        width: 100%;
        white-space: normal;
    }
    .cookie-buttons-container .btn {
        width: 100%;
    }
}
</style>